class ShareAction {
    constructor(button) {
        button.addEventListener('click', async (e) => {
            if (button.dataset.href) {
                window.open(button.dataset.href, '_blank', 'noopener,noreferrer,toolbar=0,location=0,menubar=0,height=600,width=600')
            } else if (button.dataset.clipboard) {
                navigator.clipboard.writeText(button.dataset.clipboard)
            } else if (button.dataset.mailto) {
                // window.open( button.dataset.mailto )
                location.href = button.dataset.mailto
            }
        })
    }
}

export default ShareAction


